import React from 'react';

interface StudentWithMusecash {
  id: string;
  name: string;
  avatar: string;
  currentMusecash: number;
}

interface RewardConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedStudents: StudentWithMusecash[];
  rewardAmount: number;
  onConfirm: () => void;
  isAwarding?: boolean;
}

const RewardConfirmationModal: React.FC<RewardConfirmationModalProps> = ({
  isOpen,
  onClose,
  selectedStudents,
  rewardAmount,
  onConfirm,
  isAwarding = false
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="todays-squad-modal-overlay" onClick={handleOverlayClick}>
      <div className="todays-squad-modal" style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="todays-squad-modal-header">
          <h2>Reward Confirmation</h2>
          <div className="musecash-reward">
            <span className="musecash-amount">+{rewardAmount}</span>
            <span className="musecash-icon">💰</span>
            <span className="musecash-label">Musecash</span>
          </div>
        </div>

        <div className="todays-squad-content" style={{ overflowY: 'auto', flexGrow: 1 }}>
          <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#666', fontSize: '1.1rem' }}>
            Awarding {rewardAmount} Musecash to {selectedStudents.length} student{selectedStudents.length !== 1 ? 's' : ''}
          </p>

          <div className="selected-students-grid">
            {selectedStudents.map((student) => (
              <div key={student.id} className="todays-squad-student-item">
                <div className="todays-squad-avatar-container">
                  <img
                    src={student.avatar}
                    alt={student.name}
                    className="todays-squad-avatar"
                  />
                  <div className="celebration-sparkle">✨</div>
                </div>
                <span className="todays-squad-student-name">{student.name}</span>
                <div className="musecash-display" style={{
                  marginTop: '0.5rem',
                  fontSize: '0.9rem',
                  textAlign: 'center',
                  color: '#4CAF50',
                  fontWeight: '600'
                }}>
                  <div style={{ color: '#666', fontSize: '0.8rem' }}>
                    Current: {student.currentMusecash} 💰
                  </div>
                  <div style={{ color: '#4CAF50', fontSize: '0.9rem' }}>
                    New: {student.currentMusecash + rewardAmount} 💰
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="todays-squad-footer" style={{ flexShrink: 0, padding: '1rem 2rem' }}>
          <button
            className="confirm-squad-btn"
            onClick={handleConfirm}
            disabled={isAwarding}
            style={{
              background: isAwarding ? '#ccc' : 'linear-gradient(135deg, #FFD700, #FFA500)',
              cursor: isAwarding ? 'not-allowed' : 'pointer'
            }}
          >
            {isAwarding ? (
              <>
                <span className="loading-spinner">🔄</span>
                Awarding Musecash...
              </>
            ) : (
              <>
                <span style={{ marginRight: '0.5rem' }}>💰</span>
                Confirm Reward
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RewardConfirmationModal;